// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__5LfEz","inner":"Footer_inner__1SSjk","nextIcon":"Footer_nextIcon__3kZx0","innerLeft":"Footer_innerLeft__3V5G_"};